import React, { useState } from 'react'
import { useBoolean } from 'react-use'

import authenticationAPI from 'api/authentication'
import Email from 'components/authentication/form-fields/Email'
import { SignedOutForm } from 'components/authentication/SignedOutForm'
import SignedOutFormContainer from 'components/authentication/SignedOutFormContainer'
import { UpperBackText } from 'components/authentication/UpperBackText'
import toast from 'lib/toast'
import { messageFromResponseError } from 'utils/strings'

export const FindCompany: React.FC = () => {
  const [email, setEmail] = useState('')
  const [isLoading, setIsLoading] = useBoolean(false)

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsLoading(true)

    try {
      await authenticationAPI.findCompany(email)
    } catch (err) {
      toast({
        type: 'error',
        text: messageFromResponseError(
          err,
          'Unable to send request. Please try again later.'
        )
      })
      return setIsLoading(false)
    }

    setIsLoading(false)
    toast({
      type: 'info',
      text: `Your company name has been emailed to ${email}`
    })
  }

  const handleChange = ({ target }) => setEmail(target.value)

  return (
    <SignedOutFormContainer>
      <UpperBackText to="/login/saml">Back to login</UpperBackText>
      <SignedOutForm title="Find Company" onSubmit={handleSubmit}>
        <Email
          email={email}
          handleChange={handleChange}
          isLoading={isLoading}
        />
      </SignedOutForm>
    </SignedOutFormContainer>
  )
}
